import React from 'react';
import {
  Formik,
  Field,
  Form,
} from 'formik';

import Buttonlet from 'components/Buttonlet';

type Props = {
  initialName: string,
  onCancel: () => void,
  onSubmit: (v: { name: string }) => void,
};

export default function OutfitRenameForm({
  initialName,
  onCancel,
  onSubmit,
}: Props) {
  return (
    <Formik
      initialValues={{ name: initialName }}
      onSubmit={onSubmit}
      render={({ handleSubmit, values, isSubmitting }) => (
        <Form
          className="outfit-controls__outfit-rename-form"
        >
          <Field
            autoFocus
            className="form__control outfit-controls__outfit-rename-field"
            maxlength={21}
            name="name"
            value={values.name}
          />
          <Buttonlet
            type={isSubmitting ? 'refresh' : 'check'}
            onClick={handleSubmit}
            disabled={isSubmitting}
            spin={isSubmitting}
            style={{
              minWidth: '32px',
            }}
          />
          <Buttonlet
            type="delete"
            onClick={onCancel}
            style={{
              minWidth: '32px',
            }}
          />
        </Form>
      )}
    />
  );
}